module.exports = __webpack_public_path__ + "img/omnichat-logo.6f191856.png";